import clsx from "clsx";
import styles from "./EmergencyNumber.module.scss";

interface EmergencyNumberProps {
	className?: string;
}

export const EmergencyNumber = ({ className }: EmergencyNumberProps) => {
	return (
		<div className={clsx(styles["emergency-number"], className)}>
			<strong>24/7 Emergency Number:</strong> <a href="tel:1800351747">1800 351 747</a>
		</div>
	);
};
